const launchPointNames = {
  global: 'Global',
  loginError: 'LoginError',
  findUserId: 'FindUserID'
}

export default launchPointNames
